import React from 'react';
import './Terms.css';

export default function Terms() {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <button
          onClick={() => {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            window.location.href = token ? `/?token=${token}` : '/';
          }}
        >
          ← Back
        </button>
        <h1>Welcome to PhomoCam</h1>

        <p className="intro-text">
          By using PhomoCam, you agree to these Terms of Service. Please read them carefully.
        </p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using PhomoCam, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this app. These terms constitute a legally binding agreement between you and PhomoCam.
          </p>
        </section>

        <section>
          <h2>2. Use of Service</h2>
          <p>
            PhomoCam is a photo-sharing application that uses facial recognition technology. By using our service, you consent to the collection and processing of your facial data for the purpose of identifying you in photos shared within the app.
          </p>
        </section>

        <section>
          <h2>3. Privacy & Data</h2>
          <p>
            We take your privacy seriously. Your facial recognition data is securely stored and encrypted. We do not sell or share your personal data with third parties without your explicit consent. Photos you take are stored securely in the cloud and are only accessible to you and those you explicitly share them with.
          </p>
        </section>

        <section>
          <h2>4. User Conduct</h2>
          <p>You agree to use PhomoCam responsibly and not to:</p>
          <ul>
            <li>Upload inappropriate, offensive, or illegal content</li>
            <li>Harass, abuse, or harm other users</li>
            <li>Attempt to access other users' accounts without permission</li>
            <li>Use the service for any unlawful purpose</li>
          </ul>
        </section>

        <section>
          <h2>5. Content Ownership</h2>
          <p>
            You retain ownership of all photos and content you upload to PhomoCam. By uploading content, you grant us a non-exclusive, worldwide, royalty-free license to store, process, display, and transmit your content solely for the purpose of providing our services. This license terminates when you delete your content or close your account.
          </p>
        </section>

        <section>
          <h2>6. Facial Recognition</h2>
          <p>
            Our facial recognition technology is used solely to identify you and your friends in photos for the purpose of sharing and organizing photos. You can update your facial recognition data at any time in the app settings.
          </p>
        </section>

        <section>
          <h2>7. Limitations of Liability</h2>
          <p>
            PHOMOCAM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR SECURITY. TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES AND SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, USE, OR OTHER INTANGIBLE LOSSES. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY YOU FOR THE SERVICE IN THE 12 MONTHS PRECEDING THE CLAIM.
          </p>
        </section>

        <section>
          <h2>8. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify you of any changes by posting the new Terms of Service within the app. Your continued use of PhomoCam after changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2>9. Content Moderation & User Safety</h2>
          <p>
            PhomoCam has ZERO TOLERANCE for objectionable content or abusive users. We are committed to maintaining a safe, respectful environment for all users.
          </p>
          <p>Our content moderation includes:</p>
          <ul>
            <li>User reporting system for flagging inappropriate photos and behavior</li>
            <li>User blocking functionality to prevent unwanted interactions</li>
            <li>24-hour response commitment - All reports are reviewed and acted upon within 24 hours</li>
            <li>Immediate content removal and user ejection for violations</li>
            <li>Permanent bans for serious violations or repeat offenders</li>
          </ul>
          <p>If you encounter objectionable content or abusive behavior:</p>
          <ul>
            <li>Report photos using the flag icon in the photo viewer</li>
            <li>Report or block users from their profile page</li>
            <li>Contact support directly for urgent safety concerns</li>
          </ul>
          <p>Violations will result in content removal and account termination without warning.</p>
        </section>

        <section>
          <h2>10. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability, for any reason, including violation of these terms. Upon termination, your right to use the service ceases immediately. You may also terminate your account at any time by contacting us. Sections relating to intellectual property, disclaimers, limitations of liability, and governing law shall survive termination.
          </p>
        </section>

        <section>
          <h2>11. Compliance with Laws</h2>
          <p>
            You agree to use PhomoCam in compliance with all applicable local, state, national, and international laws and regulations. We may disclose information to law enforcement or regulatory agencies if required by law or if we believe it is necessary to protect the rights, safety, and security of our users or the public.
          </p>
        </section>

        <section>
          <h2>12. Prohibited Uses & Third-Party Policies</h2>
          <p>
            You may not use PhomoCam to store, share, or transmit any content that is illegal, harmful, threatening, abusive, harassing, defamatory, obscene, hateful, or otherwise objectionable. This includes content that violates the AWS Acceptable Use Policy, Apple App Store, or Google Play Store policies. Violations may result in immediate termination of your account and reporting to appropriate authorities.
          </p>
        </section>

        <section>
          <h2>13. Age Restrictions</h2>
          <p>
            PhomoCam is not intended for use by children under the age of 13. By using the app, you confirm that you are at least 13 years old (or the minimum age required in your jurisdiction) or have the consent of a parent or guardian. In jurisdictions where local law requires parental consent for users under 16, you represent and warrant that such consent has been obtained before using PhomoCam. If you do not meet these requirements, you may not use our services.
          </p>
        </section>

        <section>
          <h2>14. Data Retention</h2>
          <p>
            We retain your data only for as long as necessary to provide our services or as required by law. Certain features, including deletion of content or biometric data, may not be fully available in this version of the app. We aim to provide full control over your data in future updates.
          </p>
        </section>

        <section>
          <h2>15. Third-Party Services</h2>
          <p>
            PhomoCam relies on third-party services, including but not limited to Amazon Web Services and Expo Application Services. We are not responsible for interruptions, outages, or data loss caused by these third-party providers.
          </p>
          <p>
            PhomoCam may allow you to (a) import photos from Apple iCloud Photos into the app, and (b) sync or export photos from the app back to your iCloud Photos. By enabling these features, you authorize PhomoCam to access your iCloud Photo library through Apple's APIs solely for the purpose of carrying out your requested import or sync.
          </p>
          <p>
            We do not control and are not responsible for the availability, security, or performance of Apple's iCloud services. Syncing or transfer of photos may be subject to delays, errors, or interruptions outside of our control.
          </p>
          <p>
            You remain responsible for maintaining backups of your photos in your iCloud account or elsewhere. PhomoCam does not guarantee that all photos will successfully import to or sync with iCloud Photos.
          </p>
        </section>

        <section>
          <h2>16. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless PhomoCam, its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses (including legal fees) arising from: (a) your use of the service; (b) your violation of these terms; (c) your violation of any rights of others; or (d) your content uploaded to the service.
          </p>
        </section>

        <section>
          <h2>17. No Guarantee of Data Security</h2>
          <p>
            While we take reasonable measures to protect your data, no method of transmission or storage is 100% secure. You acknowledge and accept that we cannot guarantee the absolute security of your information.
          </p>
        </section>

        <section>
          <h2>18. Dispute Resolution</h2>
          <p>
            Any disputes arising from these terms or your use of PhomoCam shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. You waive any right to participate in class action lawsuits or class-wide arbitration. This arbitration clause does not apply to claims related to intellectual property rights.
          </p>
        </section>

        <section>
          <h2>19. Governing Law</h2>
          <p>
            These terms are governed by and construed in accordance with the laws of the State of California, without regard to conflict of law principles. Any legal action must be brought in the federal or state courts located in San Francisco County, California.
          </p>
        </section>

        <section>
          <h2>20. Severability</h2>
          <p>
            If any provision of these terms is found to be unenforceable, the remainder shall continue in full force and effect. The unenforceable provision shall be replaced with an enforceable provision that most closely reflects the original intent.
          </p>
        </section>

        <section>
          <h2>21. Contact Us</h2>
          <p>
            For questions about these Terms of Service, please visit our <a href={`/support${window.location.search ? window.location.search + '&from=terms' : '?from=terms'}`}>Support Page</a> or contact us directly at: <a href="mailto:prasiddha@gmail.com">prasiddha@gmail.com</a>.
          </p>
        </section>

        <p className="last-updated">Last updated: September 4th, 2025</p>
      </div>

      {/* Footer */}
      <div className="terms-footer">
        © 2025 PhomoCam. Share memories, not just photos.
      </div>
    </div>
  );
}